import { LogLevel } from '@azure/msal-browser';

export const GET_ROLE_REQUEST = 'GET_ROLE_REQUEST' as const;
export const GET_ROLE_SUCCESS = 'GET_ROLE_SUCCESS' as const;
export const GET_ROLE_ERROR = 'GET_ROLE_ERROR' as const;
export const CLEAR_ROLE_ERROR = 'CLEAR_ROLE_ERROR' as const;

export const GET_ACCOUNT = 'GET_ACCOUNT' as const;
export const SET_ACCOUNT = 'SET_ACCOUNT' as const;
export const SWITCH_USER_ROLE = 'SWITCH_USER_ROLE' as const;

export const msalScopes = [
  process.env.REACT_APP_AZURE_READACCESS_SCOPE_ID,
  process.env.REACT_APP_AZURE_WRITEACCESS_SCOPE_ID,
];

export const msalScopesOfWeightService = [process.env.REACT_APP_AZURE_WEIGHTSERVICE_SCOPE_ID];

const baseUrl = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_PROD_URL : 'http://localhost:3000';

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID,
    authority: process.env.REACT_APP_AZURE_AUTORITY,
    redirectUri: `${baseUrl}/auth`,
    postLogoutRedirectUri: `${baseUrl}`,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: 'localStorage',
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: LogLevel, message: string, containsPii: boolean): void => {
        if (containsPii) {
          return;
        }
        // eslint-disable-next-line
        switch (level) {
          case LogLevel.Error:
            // eslint-disable-next-line no-console
            console.error(message);
            return;
          case LogLevel.Verbose:
            // eslint-disable-next-line no-console
            console.debug(message);
            return;
          case LogLevel.Warning:
            // eslint-disable-next-line no-console
            console.warn(message);
            // eslint-disable-next-line
            return;
        }
      },
    },
  },
};
